import type { NlsKey } from '../../nls/strings_nls'
import type { TimelineBoardKey } from '../../types/schema'

type NlsT = (key: NlsKey, values?: Record<string, string | number>) => string

export const MANAGE_BOARD_LABEL_KEYS: Record<TimelineBoardKey, NlsKey> = {
  VISIONBOARD: 'NLSManageBoardVisionboard',
  DASHBOARD: 'NLSManageBoardDashboard',
  ARCHIVE: 'NLSManageBoardArchive',
  BIN: 'NLSManageBoardBin',
}

export const getManageBoardLabel = (t: NlsT, board: TimelineBoardKey): string => t(MANAGE_BOARD_LABEL_KEYS[board])

export const getManageBoardOptions = (
  t: NlsT,
  boards: TimelineBoardKey[],
): Array<{ value: TimelineBoardKey; label: string }> =>
  boards.map((board) => ({ value: board, label: getManageBoardLabel(t, board) }))

export const getManageKindLabel = (
  t: NlsT,
  kind: 'goal' | 'task' | 'subtask' | 'item',
): string => {
  if (kind === 'goal') return t('NLSManageKindGoal')
  if (kind === 'task') return t('NLSManageKindTask')
  if (kind === 'subtask') return t('NLSManageKindSubtask')
  return t('NLSManageKindItem')
}

export const getManageParentKindLabels = (
  t: NlsT,
  requiredParentType: 'GOAL' | 'TASK',
): { singular: string; plural: string } =>
  requiredParentType === 'GOAL'
    ? { singular: t('NLSManageKindGoal'), plural: t('NLSManageKindGoalPlural') }
    : { singular: t('NLSManageKindTask'), plural: t('NLSManageKindTaskPlural') }

export const getManageSaveDiscardLabels = (t: NlsT) => ({
  save: t('NLSManageActionSave'),
  saveAllChildItems: t('NLSManageActionSaveAllChildItems'),
  saveAll: t('NLSManageActionSaveAll'),
  discard: t('NLSManageActionDiscard'),
  discardAllUnsaved: t('NLSManageActionDiscardAllUnsaved'),
  discardAll: t('NLSManageActionDiscardAll'),
})

export const getManagePerItemDiscardCopy = (
  t: NlsT,
  count: number,
) => ({
  title: t('NLSManageDialogPerItemTitle'),
  body: t('NLSManageDialogPerItemBody', {
    count,
    noun: count === 1 ? t('NLSManageKindItem') : t('NLSManageKindItems'),
  }),
  saveToBin: t('NLSManageActionSaveToBin'),
  drop: t('NLSManageActionDrop'),
  keepEditing: t('NLSManageActionKeepEditing'),
  applyClose: t('NLSManageActionApplyAndClose'),
  applyStayOpen: t('NLSManageActionApplyStayOpen'),
})
